// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otp-input {
  height: 40px;
  color: #353535;
  min-width: 40px;
  max-width: 40px;
  font-size: 20px;
  text-align: center;
  background-color: #fcfcfc;
  border-radius: 8px;
  border: 0.5px solid #eaeaea;
}

/* For Chrome, Safari, Edge, and Opera */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* For Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomOTPInput.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,0BAA0B;AAC5B","sourcesContent":[".otp-input {\n  height: 40px;\n  color: #353535;\n  min-width: 40px;\n  max-width: 40px;\n  font-size: 20px;\n  text-align: center;\n  background-color: #fcfcfc;\n  border-radius: 8px;\n  border: 0.5px solid #eaeaea;\n}\n\n/* For Chrome, Safari, Edge, and Opera */\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* For Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
